<form class="form-row" [formGroup]="formGroup">
  <div class="col-12 mb-2 label">{{ field.label }}<span *ngIf="isRequire" class="text-danger">*</span></div>
  <textarea
    class="form-control h-auto"
    [id]="field?.id || field.fieldName"
    [attr.data-id]="field?.id || field.fieldName"
    [formControlName]="field.fieldName"
    [placeholder]="field.optionTextareaField?.placeholder || field.label"
    [rows]="field.optionTextareaField?.rows || rows"
    [ngClass]="{
      'is-invalid': isSubmitted && formGroup.get(field.fieldName)?.errors
    }"
  ></textarea>
  <span *ngIf="field?.optionTextareaField?.info" class="info mt-1">
    {{ field.optionTextareaField?.info }}
  </span>
  <div *ngIf="isSubmitted && control?.errors?.required" class="invalid-feedback d-block">
    {{ 'ERRORS.REQUIRED' | translate }}
  </div>
</form>
